import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Environment } from '@core/services/common';
import { interval } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {

  private baseUrl = 'https://maps.googleapis.com/maps/api';
  private libraries = 'libraries=geometry,places';
  private isReady = false;

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }

  ready() {
    if (this.isReady) { return Promise.resolve(); }
    return this.addScriptTag();
  }

  private addScriptTag() {
    return new Promise<void>(resolve => {
      if (this.document.getElementById('script_googlemaps')) {
        if (this.isReady) {
          resolve();
          return;
        } else {
          const source = interval(100);
          const subscribe = source.subscribe(() => {
            if (this.isReady) {
              resolve();
              subscribe.unsubscribe();
            }
          });
          return;
        }
      }
      const body = this.document.getElementsByTagName('body')[0];
      const script = this.document.createElement('script');
      const apiKey = Environment.config().mapsApiKey;
      script.id = 'script_googlemaps';
      script.type = 'text/javascript';
      script.src = `${this.baseUrl}/js?key=${apiKey}&${this.libraries}&callback=Function.prototype`;
      script.defer = true;
      script.async = true;
      if ((script as any).readyState) { // IE
        const iescript = script as any;
        iescript.onreadystatechange = () => {
          iescript.onreadystatechange = null;
          this.isReady = (iescript.readyState === 'loaded' || iescript.readyState === 'complete');
          resolve();
        };
      } else { // Others
        script.onload = () => {
          this.isReady = true;
          resolve();
        };
        script.onerror = () => {
          this.isReady = false;
          resolve();
        };
      }
      body.appendChild(script);
    });
  }

}
